var getParamsKey = function getParamsKey(params) {
  var str = params ? JSON.stringify(params) : "";
  var len = str.length; // simple non-secure hashing
  // from https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript

  var key = 0;

  if (len === 0) {
    return key;
  }

  for (var i = 0; i < len; i++) {
    key = (key << 5) - key + str.charCodeAt(i);
    key = key & key; // Convert to 32bit integer
  }

  return key;
};

var compareParams = function compareParams(paramsA, paramsB) {
  return getParamsKey(paramsA) === getParamsKey(paramsB);
};

export { compareParams, getParamsKey };
